import { render, staticRenderFns } from "./uvjeti.vue?vue&type=template&id=1868bf46&"
import script from "./uvjeti.vue?vue&type=script&lang=js&"
export * from "./uvjeti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports